var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel__header"},[_c('h5',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"main-nav__close",on:{"click":_vm.closePanel}},[_c('span',{staticClass:"icon"})])])}
var staticRenderFns = []

export { render, staticRenderFns }